import { FlexColumn } from "@/components/layout/FlexBox";
import { Heading } from "@/components/Typography";
import { Wine } from "@/models/wine";
import { toLiter } from "@/utils/transformers/toLiter";
import { toReadableTemperature } from "@/utils/transformers/toTemperatureRange";
import s from "./Specifications.module.scss";

interface Props {
	specs: Wine["acf"];
}

export default function Specifications({ specs }: Props) {
	return (
		<div className={s.specifications}>
			{specs.grapes && (
				<FlexColumn gap={4} className={s.full_column}>
					<Heading as="h5" sizeMobile="xxs" sizeDesktop="xxs">
						Druivenras
					</Heading>
					<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
						{specs.grapes.map((variety) => variety.grape).join(", ")}
					</Heading>
				</FlexColumn>
			)}
			<div>
				<Heading as="h5" sizeMobile="xxs" sizeDesktop="xxs">
					Oogstjaar
				</Heading>
				<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
					{specs.year || "N.v.t."}
				</Heading>
			</div>
			{specs.color && (
				<div>
					<Heading as="h5" sizeMobile="xxs" sizeDesktop="xxs">
						Type
					</Heading>
					<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
						{specs.color.name}
					</Heading>
				</div>
			)}
			{specs.alcohol_percentage && (
				<div>
					<Heading as="h5" sizeMobile="xxs" sizeDesktop="xxs">
						Alcohol
					</Heading>
					<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
						{`${specs.alcohol_percentage}%`}
					</Heading>
				</div>
			)}
			{specs.taste_profile && (
				<div>
					<Heading as="h5" sizeMobile="xxs" sizeDesktop="xxs">
						Smaak
					</Heading>
					<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
						{specs.taste_profile.name}
					</Heading>
				</div>
			)}
			{specs.drinking_temperature && (
				<div>
					<Heading as="h5" sizeMobile="xxs" sizeDesktop="xxs">
						Drink temp.
					</Heading>
					<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
						{toReadableTemperature(specs.drinking_temperature)}
					</Heading>
				</div>
			)}
			{specs.region && (
				<div>
					<Heading as="h5" sizeMobile="xxs" sizeDesktop="xxs">
						Streek
					</Heading>
					<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
						{specs.country.name
							? `${specs.region}, ${specs.country.name}`
							: specs.region}
					</Heading>
				</div>
			)}
			{specs.bottle_contents && (
				<div>
					<Heading as="h5" sizeMobile="xxs" sizeDesktop="xxs">
						Inhoud
					</Heading>
					<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
						{toLiter(specs.bottle_contents, true)}
					</Heading>
				</div>
			)}
			{specs.classification && (
				<div>
					<Heading as="h5" sizeMobile="xxs" sizeDesktop="xxs">
						Classificatie
					</Heading>
					<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
						{specs.classification}
					</Heading>
				</div>
			)}
		</div>
	);
}
